import React from "react";
import Modal from "react-modal";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { useAuth } from "../../context/AuthContext";
import logoImg from "../../assets/logo2.png";

const traduzirStatus = (status) => {
  switch (status?.toUpperCase?.()) {
    case "PAGO":
      return "Pago";
    case "PENDENTE":
      return "Pendente";
    case "PARCIAL":
      return "Parcial";
    default:
      return status || "—";
  }
};

const gerarReciboMensalidade = (mensalidade, operador = "Operador desconhecido") => {
  if (!mensalidade) return;

  const doc = new jsPDF();

  const nomeEscola = "Escola Vida Abundante";
  const emailEscola = "escolavidaabundante7gmail.com";
  const localizacao = "Matola, Machava Km 15 Nkomane";
  const nuit = "700067254";
  const desenvolvedor = "Chaúca Creative";

  const img = new Image();
  img.src = logoImg;
  img.onload = () => {
    const maxWidth = 40;
    const scale = maxWidth / img.width;
    const imgWidth = maxWidth;
    const imgHeight = img.height * scale;

    doc.addImage(img, "PNG", 10, 10, imgWidth, imgHeight);

    // Cabeçalhos
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("ACADE – Gestor Escolar", 60, 15);

    doc.setFont("helvetica", "italic");
    doc.setFontSize(12);
    doc.text("Recibo de Mensalidade", 60, 23);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(nomeEscola, 60, 30);
    doc.text(`Email: ${emailEscola}`, 60, 36);
    doc.text(`Localização: ${localizacao}`, 60, 42);
    doc.text(`NUIT: ${nuit}`, 60, 48);

    const now = new Date().toLocaleString("pt-AO");
    doc.text(`Data: ${now}`, 200, 20, { align: "right" });
    doc.text(`Operador: ${operador}`, 200, 26, { align: "right" });
    doc.text(
      `Recibo Nº: ${mensalidade.referencia || "—"}`,
      200,
      32,
      { align: "right" }
    );

    const detalhesPagamento = mensalidade.detalhes
  ? [
      mensalidade.detalhes.telefone
        ? `Tel: ${mensalidade.detalhes.telefone}`
        : null,
      mensalidade.detalhes.referencia
        ? `Ref: ${mensalidade.detalhes.referencia}`
        : null,
    ]
      .filter(Boolean)
      .join(" | ")
  : "—";

    // Colunas do PDF
    const colunas = ["Campo", "Detalhes"];
    const dados = [
  ["Aluno", mensalidade.nome_completo],
  ["Código do Aluno", mensalidade.codigo_aluno],
  ["Classe / Turma", `${mensalidade.classe} - ${mensalidade.turma}`],
  ["Referência", mensalidade.referencia],
  ["Mês/Ano", mensalidade.mesAnoExibicao],

  ["Valor Mensal", `${mensalidade.valor_base.toLocaleString("pt-AO")} MZN`],
  ["Multa", `${mensalidade.valor_multa.toLocaleString("pt-AO")} MZN`],
  ["Pago", `${mensalidade.valor_pago.toLocaleString("pt-AO")} MZN`],
  ["Saldo", `${mensalidade.saldo.toLocaleString("pt-AO")} MZN`],

  ["Forma de Pagamento", mensalidade.forma_pagamento],
  ["Detalhes do Pagamento", detalhesPagamento],
  ["Entidade", mensalidade.entidade],
  ["Estado", traduzirStatus(mensalidade.estado)],
];

    autoTable(doc, {
      head: [colunas],
      body: dados,
      startY: 55,
      styles: { fontSize: 11, cellPadding: 4 },
      headStyles: { fillColor: [22, 160, 133], textColor: 255, halign: "center" },
      columnStyles: {
        0: { cellWidth: 60, fontStyle: "bold" },
        1: { cellWidth: 120 },
      },
    });

    // Rodapé
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const pageNumber = doc.internal.getNumberOfPages();

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(
      `Software: ACADE-Gestor Escolar | Página ${pageNumber} de ${pageNumber}.`,
      14,
      pageHeight - 15
    );

    doc.setDrawColor(150);
    doc.line(14, pageHeight - 13, pageWidth - 14, pageHeight - 13);

    doc.setFont("helvetica", "italic");
    doc.text(`Desenvolvido por ${desenvolvedor}`, pageWidth - 14, pageHeight - 8, { align: "right" });

    const nomeArquivo = `recibo_mensalidade_${mensalidade.codigo_aluno || "desconhecido"}.pdf`;
    doc.save(nomeArquivo);
  };
};

const ReciboMensalidades = ({ mensalidade, onClose }) => {
  const { user } = useAuth();
  const operadorEmail = user?.email || "Operador desconhecido";

  if (!mensalidade) return null;

  return (
    <Modal
      isOpen={true}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        },
        content: {
          inset: "unset",
          padding: "30px 40px",
          background: "#fff",
          borderRadius: "12px",
          maxWidth: "700px",
          width: "90%",
          maxHeight: "90vh",
          overflowY: "auto",
        },
      }}
      ariaHideApp={false}
    >
      <h2>Recibo de Mensalidade</h2>
      <button
        onClick={() => gerarReciboMensalidade(mensalidade, operadorEmail)}
      >
        Exportar PDF
      </button>
      <button onClick={onClose}>Fechar</button>
    </Modal>
  );
};

export default ReciboMensalidades;
export { gerarReciboMensalidade };
